export const autoBlur = {
  mounted(el) {
    // Attach click event to blur the element after click
    el.addEventListener('click', () => {
      el.blur();
    });
  },
  unmounted(el) {
    // Remove the event listener when element is unmounted to prevent memory leaks
    el.removeEventListener('click', () => {
      el.blur();
    });
  }
};